import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import './App.css';
import Login from './components/Login';
import MainPage from './components/MainPage';
import ProjectLanding from './components/ProjectLanding';
import ParametersBadgeDemo from './components/ParametersBadgeDemo';
import { ThemeProvider } from './contexts/ThemeContext';
import './components/MainPage.css';

// Add axios interceptor for authentication
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);  }
);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));

  const handleLogout = useCallback(() => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
  }, []);

  // Placeholder for create project action
  const handleCreateProject = () => {
    alert('Create New Project clicked! (Implement project creation logic here)');
  };
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route 
              path="/login" 
              element={!isAuthenticated ? <Login setIsAuthenticated={setIsAuthenticated} /> : <Navigate to="/main" />} 
            />          <Route 
              path="/main" 
              element={
                isAuthenticated ? (
                  <MainPage onCreateProject={handleCreateProject} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" />
                )
              } 
            />          
            <Route 
              path="/demo/parameters" 
              element={
                isAuthenticated ? (
                  <ParametersBadgeDemo />
                ) : (
                  <Navigate to="/login" />
                )
              } 
            />
            <Route 
              path="/project/:projectId" 
              element={
                isAuthenticated ? (
                  <ProjectLanding onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" />
                )
              } 
            />
            {/* Fallback: redirect root to /main if authenticated, else to /login */}
            <Route 
              path="/" 
              element={<Navigate to={isAuthenticated ? "/main" : "/login"} />} 
            />
          </Routes>
          
          {/* Fixed Footer */}
          <footer className="app-footer">
            <p>© Rapidcmc 2025 – All rights reserved.</p>
          </footer>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
